var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox',{attrs:{"disabled":_vm.disabled || _vm.config.Disabled},on:{"change":_vm.OnChange},model:{value:(_vm.Data),callback:function ($$v) {_vm.Data=$$v},expression:"Data"}},[_vm._v(_vm._s(_vm.Text))])
}
var staticRenderFns = []

export { render, staticRenderFns }